/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GenerateUserPinPathParameters } from 'api/actions/generate-user-pin/generate-user-pin-path-parameters';
import { GenerateUserPinResponse } from 'api/actions/generate-user-pin/generate-user-pin-response';

type GenerateUserPinQueryParameters = Record<string, any>;

/**
 * The path of the GenerateUserPin action.
 */
export const generateUserPinActionPath = new SweetPath<keyof GenerateUserPinPathParameters>('/user/pin/generate', {
  path: '{param}',
});

/**
 * Creates a contextualized GenerateUserPin actions.
 */
export default function createGenerateUserPinAction(axios: AxiosInstance) {
  return function generateUserPinAction({
    headers = {},
    query = {},
  }: { headers?: AxiosRequestConfig<any>['headers']; query?: GenerateUserPinQueryParameters } = {}) {
    const path = generateUserPinActionPath.original;

    return axios.post<GenerateUserPinResponse, GenerateUserPinResponse>(path, { params: query, headers });
  };
}
